import React, { useState, useEffect } from 'react'
import { Phone, MapPin, X } from 'lucide-react'
import LogoDesktop from '../../assets/img/FullLogo_Transparent_NoBuffer.webp'
import LogoMobile from '../../assets/img/b2bglob_logo.webp'
import ReactCountryFlag from "react-country-flag"
import './Header.css'
import { MenuItem, Menu, Button } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu';
import { useTranslation } from 'react-i18next'
const CommonHeader = () => {
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
	const [selectedItem, setSelectedItem] = useState(1)
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);

	const { t } = useTranslation();
	const { i18n } = useTranslation();
	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen)
	}
	const handleMenuOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleMenuItemClick = (event, value) => {
		var language = value === 1 ? "FR" : "EN"
		event.stopPropagation();
		setSelectedItem(value);
		localStorage.setItem('language', language);
		i18n.changeLanguage(language.toLowerCase());
		setAnchorEl(null);

	};
	useEffect(() => {
		const savedLanguage = localStorage.getItem('language');

		if (savedLanguage === "EN") {
			setSelectedItem(2);
		} else {
			setSelectedItem(1);
		}
	}, []);
	const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setIsMobile(window.innerWidth <= 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);
	return (
		<header className='header'>
			{/* Logo Section - Desktop Only */}
			<div className='logo-section desktop-only'>
				<div className='logo-container'>
                    <img
                     src={LogoDesktop}
                     alt="B2BGLOB"
                     className="logo"
                     loading="eager"
                     decoding="async"
					 width="180"
                     height="60"
                    />
				</div>
			</div>

			{/* Main Content Section */}
			<div className='content-section'>
				{/* Top Bar with Contact Info */}
				<div className='top-bar'>
					<div className='top-bar-content' >
						<div className='contact-item' >
							<Button
								onClick={handleMenuOpen}
								id="language-button"
								aria-controls={open ? 'language-menu' : undefined}
								aria-haspopup="true"
								aria-expanded={open ? 'true' : undefined}
								style={{
									color : 'white',
									gap : '8px'
								}}
							>
								<ReactCountryFlag countryCode={selectedItem === 1 ? "FR" : "US"} svg />
								<span>{selectedItem === 1 ? "FR" : "EN"}</span>
</Button>
								<Menu
									id="language-menu"
									anchorEl={anchorEl}
									open={open}
									onClose={handleMenuClose}

									slotProps={{
										list: {
											'aria-labelledby': 'language-button',
										},
									}}

								>
									<MenuItem
										onClick={(event) => handleMenuItemClick(event, 1)}
										style={{ display: 'flex', gap: 5 }}
									>
										<ReactCountryFlag countryCode="FR" svg />
										FR
									</MenuItem>
									<MenuItem
										onClick={(event) => handleMenuItemClick(event, 2)}
										style={{ display: 'flex', gap: 5 }}
									>
										<ReactCountryFlag countryCode="US" svg />
										EN
									</MenuItem>
								</Menu>
							
						</div>
						<div className='contact-info'>
							<div className='contact-item'>
								<Phone size={16} />
								<span>+33 01 45 67 43 22</span>
							</div>
							<div className='contact-item'>
								<MapPin size={16} />
								<span>
									74 avenue Gambetta 75020 Paris France
								</span>
							</div>
						</div>
					</div>
				</div>

				{/* Navigation Bar */}
				<div className='main-nav'>
					<div className='nav-content'>
						{/* Mobile Logo - Mobile Only */}
						<div className='mobile-logo mobile-only'>
							<img
                              src={LogoMobile}
                              alt="B2BGLOB"
                              className="logo"
                              loading="lazy"
                              decoding="async"
							  width="180"
                              height="60"
                            />
						</div>
						<div style={{ display: 'flex', gap: '5px' }}>
							{isMobile && <div className='contact-item' onClick={handleMenuOpen}>
								<ReactCountryFlag countryCode={selectedItem === 1 ? "FR" : "US"} svg />
								<span>{selectedItem === 1 ? "FR" : "EN"}</span>

								<Menu
									id="language-menu"
									anchorEl={anchorEl}
									open={open}
									onClose={handleMenuClose}
									keepMounted
									anchorOrigin={{
										vertical: 'bottom',
										horizontal: 'left',
									}}
									transformOrigin={{
										vertical: 'top',
										horizontal: 'left',
									}}
									autoFocus={false}

								>
									<MenuItem
										onClick={(event) => handleMenuItemClick(event, 1)}
										style={{ display: 'flex', gap: 5 }}
									>
										<ReactCountryFlag countryCode="FR" svg />
										FR
									</MenuItem>
									<MenuItem
										onClick={(event) => handleMenuItemClick(event, 2)}
										style={{ display: 'flex', gap: 5 }}
									>
										<ReactCountryFlag countryCode="US" svg />
										EN
									</MenuItem>
								</Menu>
							</div>}
							{/* Mobile Menu Button */}
							<button
								className='mobile-menu-btn'
								onClick={toggleMobileMenu}
								aria-label='Toggle menu'
							>
								{isMobileMenuOpen ? (
									<X size={24} />
								) : (
									<MenuIcon size={24} />
								)}
							</button>
						</div>

						{/* Navigation Links */}
						<nav
							className={`nav-links ${isMobileMenuOpen ? 'mobile-open' : ''}`}
						>
							<a href='/' className='nav-link'>
								{t("accueil")}
							</a>
							<a href='/CreateAccount' className='nav-link'>
								{t("create_account")}
							</a>
							<a href='/contact' className='nav-link'>
								{t("contact")}
							</a>
							<a href='/login' className='nav-link'>
								{t("login")}
							</a>
						</nav>
					</div>
				</div>
			</div>
		</header>
	)
}

export default CommonHeader

